export default "__VITE_ASSET__0a0c274f__"